import React from "react";

const Hero: React.FC = () => {
  return (
    <section className="py-12 text-center bg-white">
      <div className="container px-4 mx-auto sm:px-6 lg:px-8">
        <p className="text-gray-600">Benvenuti in</p>
        <h1 className="my-2 text-4xl font-bold text-gray-800">
          CO.ME.ST. S.r.l.
        </h1>
        <div className="grid gap-8 mt-12 md:grid-cols-3">
          <div className="flex flex-col items-center">
            <div className="bg-[#3b5998] rounded-full h-16 w-16 flex items-center justify-center mb-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-8 h-8 text-white"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <h2 className="mb-2 text-xl font-semibold text-gray-800">
              Stampaggio e Assemblaggio Lamiere e Alluminio
            </h2>
            <p className="text-sm text-gray-600">
              Stampaggio progressivo, automatizzato e assemblaggio di componenti
              in lamiera e alluminio per Automotive e non solo.
            </p>
          </div>
          <div className="flex flex-col items-center">
            <div className="bg-[#3b5998] rounded-full h-16 w-16 flex items-center justify-center mb-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-8 h-8 text-white"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.536L16.732 3.732z"
                />
              </svg>
            </div>
            <h2 className="mb-2 text-xl font-semibold text-gray-800">
              Progettazione Stampi e Attrezzature
            </h2>
            <p className="text-sm text-gray-600">
              Studio di fattibilità ed industrializzazione. Progettazione su
              stazioni Vero Visi Hexagon, Tebis. Sviluppo progetti in totale
              autonomia, prototipazione veloce, attrezzamento di bassa cadenza,
              setup con presse di prova prima della messa in produzione.
            </p>
          </div>
          <div className="flex flex-col items-center">
            <div className="bg-[#3b5998] rounded-full h-16 w-16 flex items-center justify-center mb-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-8 h-8 text-white"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                />
              </svg>
            </div>
            <h2 className="mb-2 text-xl font-semibold text-gray-800">
              Realizzazione Stampi
            </h2>
            <p className="text-sm text-gray-600">
              Sviluppo e realizzazione di stampi a blocco, stampi progressivi,
              attrezzature di assemblaggio, calibri di controllo. Realizzazione
              mediante moderne stazioni a controllo numerico.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
